import './ItemNotesDialog.scss';

interface ItemNotesDialogProps {
  open: boolean;
  onClose: () => void;
  item?: { cancellationReason?: string | null; rejectionReason?: string | null } | null;
}

export function ItemNotesDialog({ open, onClose, item }: ItemNotesDialogProps) {
  if (!open) return null;
  const hasUser = !!item?.cancellationReason;
  const hasOrg = !!item?.rejectionReason;
  const empty = !hasUser && !hasOrg;

  return (
    <div className="modal" role="dialog" aria-modal="true" aria-labelledby="notes-title">
      <div className="modal__backdrop" onClick={onClose} />
      <div className="modal__panel">
        <div className="modal__header">
          <h3 id="notes-title" className="modal__title">
            Item notes
          </h3>
        </div>
        <div className="modal__body">
          {empty ? (
            <div className="muted">No notes on this item yet.</div>
          ) : (
            <div className="notes-stack">
              {hasUser && (
                <div className="note-card">
                  <div className="note-title">User cancellation note</div>
                  <div className="note-body">{item.cancellationReason}</div>
                </div>
              )}
              {hasOrg && (
                <div className="note-card">
                  <div className="note-title">Org rejection note</div>
                  <div className="note-body">{item.rejectionReason}</div>
                </div>
              )}
            </div>
          )}
        </div>
        <div className="modal__footer">
          <button className="btn btn--ghost" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
